// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "-legacy." + {"131":"25185955","194":"07523225","260":"023729cd","440":"f2b874f0","509":"1dc74e0a","581":"e9ce0b80","668":"c6027928","762":"32c2efd8","811":"b95d5847","902":"75d3a72d","973":"4d7eea13","983":"89a65e57"}[chunkId] + ".js";
};